import { authI18nEnUs } from '@luigiclaudio/ga-auth-theme';

const authMessagesEnUs = {
    ...authI18nEnUs,
};

export default authMessagesEnUs;
